import publicApiInstance from './PublicApiService';

export const sendForgotPasswordOTP = async (email: string) => {
  try {
    const response = await publicApiInstance.post('/forgot-password/send-otp', { email });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to send OTP');
  }
};

export const verifyForgotPasswordOTP = async (email: string, otp: string) => {
  try {
    const response = await publicApiInstance.post('/forgot-password/verify-otp', { email, otp });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to verify OTP');
  }
};

export const resetPasswordWithOTP = async (email: string, otp: string, newPassword: string, confirmPassword: string) => {
  try {
    const response = await publicApiInstance.post('/forgot-password/reset-password', {
      email,
      otp,
      newPassword,
      confirmPassword
    });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to reset password');
  }
};